import './nav.css'
import React, {useEffect, useState, useRef} from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import NavRightSvg from '../svg/home/NavRightSvg';
import Wechat from '../svg/home/Wechat'
import CrossSvg from '../svg/CrossSvg'
function Component({rightNav, handleSetRightNav}) {
  const [delayNav, setDelayNav] = useState(false)
  const navigate = useNavigate();
  const location = useLocation()
  const navRef = useRef()
  const curScreen = location.pathname
  const relative = location.pathname === '/newlanding/' ? './' : '../'
useEffect(() => {
    let timer = undefined
    if(!rightNav){
        timer = setTimeout(() => setDelayNav(rightNav), 200)
        setTimeout(() => {
            if(navRef.current)navRef.current.style.display = 'none'
        },200)
    }else{
        if(navRef.current)navRef.current.style.display = 'flex'
        setDelayNav(rightNav)
    }
},[rightNav])
  function navigating(str){
    // setCurScreen(str)
    handleSetRightNav(false)
    navigate(str)
  }


  if(!delayNav) return <></>
  return (
    <div className={'fixed top-0 left-0 w-[100vw] h-[100vh] ' + (rightNav ? 'fade-in-me' : 'fade-out-me')} style={{zIndex:9999999999999999999}}>
        <div className='inset-0 absolute cursor-pointer' onClick={() => handleSetRightNav(false)}></div>
            <div className={'absolute right-0 flex flex-col w-[30vw] h-[100vh] bg-[#fff] px-8 pb-[44px] pt-[6px] min-w-[375px] overflow-auto justify-between ' + (rightNav ? 'slide-in-right' : 'slide-out-right')} style={{zIndex:100}}>
                <div className='flex flex-row items-center justify-between'>
                    <img className='w-[133px] appear_opacity' src={`${relative}img/home/top_banner_icon.png`} style={{aspectRatio:489/141}}></img>
                    <CrossSvg onClick={() => handleSetRightNav(false)} className='cursor-pointer'/>
                </div>
                <nav className=''>
                    <ul className='flex h-full flex-col items-center justify-center'>
                            <div onClick={() => navigating('/newlanding/')} className='cursor-pointer select-none h-full px-6 flex flex-col items-center justify-center relative py-[12px] mb-[24px]'>
                                首頁
                                {curScreen === '/newlanding/' && <div className='w-[100%] h-[4px] bg-[#AEA373] absolute bottom-[3%]'></div>}
                            </div>
                            <div onClick={() => navigating('/newlanding/aboutus/')} className='cursor-pointer h-full px-6 flex flex-col items-center justify-center relative py-[12px] mb-[24px]'>
                                關於T.Gather
                                {curScreen === '/newlanding/aboutus/' && <div className='w-[100%] h-[4px] bg-[#AEA373] absolute bottom-[3%]'></div>}
                            </div>
                            <div onClick={() => navigating('/newlanding/specialties/')} className='cursor-pointer select-none h-full px-6 flex flex-col items-center justify-center relative py-[12px] mb-[24px]'>
                                平台特色
                                {curScreen === '/newlanding/specialties/' &&<div className='w-[100%] h-[4px] bg-[#AEA373] absolute bottom-[3%]'></div>}
                            </div>
                            <div onClick={() => navigating('/newlanding/register/')} className='cursor-pointer select-none h-full px-6 flex flex-col items-center justify-center relative py-[12px] mb-[24px]'>
                                登記
                                {curScreen === '/newlanding/register/' &&<div className='w-[100%] h-[4px] bg-[#AEA373] absolute bottom-[3%]'></div>}
                            </div>
                    </ul>
                </nav>
                <div className='flex flex-row items-center justify-end' style={{gap:'36px'}}>
                    <NavRightSvg className='cursor-pointer'/>
                    <Wechat className='cursor-pointer'/>
                </div>
            </div>
    </div>
  );
}

export default Component